var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlusCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#plus-circle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 2.667a7.333 7.333 0 1 0 0 14.666 7.333 7.333 0 0 0 0-14.666M.667 10a9.333 9.333 0 1 1 18.666 0A9.333 9.333 0 0 1 .667 10M10 5.667a1 1 0 0 1 1 1V9h2.333a1 1 0 1 1 0 2H11v2.333a1 1 0 0 1-2 0V11H6.667a1 1 0 0 1 0-2H9V6.667a1 1 0 0 1 1-1",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "plus-circle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
SvgPlusCircle.displayName = "SvgPlusCircle";
export { SvgPlusCircle as ReactComponent };
export default SvgPlusCircle;